<template>

  <div class="row mt-3">
    <h3 class="col-12 col-md-9"> {{ controllerData.name }}</h3> 
    <div class= "col-3">
      <DxButton
        text="Apply changes"
        type="success"
        width="100%"
        @click="saveControllerChanges"
      />  
    </div>
    
    <!-- Common settings -->
    <DxForm :form-data="controllerData"  label-location="left" :min-col-width="350">
      <DxGroupItem :col-count="2" :min-col-width="350" caption="General settings">
        <DxSimpleItem data-field="name" 
        :editor-options="{ disabled: true }" />
        
        <DxSimpleItem 
          data-field="description" 
          editor-type="dxTextBox"
          :editor-options="{ maxLength: 300 }" 
        />
        <DxSimpleItem
          data-field="compType"
          editor-type="dxSelectBox"
          :editor-options="{ dataSource: controllerList, valueExpr:'id', displayExpr:'label', disabled:true }"
          :label="{ text: 'type Controller'}"
        />
        <DxSimpleItem data-field="isEnabled" editor-type="dxCheckBox" />
        
      </DxGroupItem>
    </DxForm>


    <!-- specific settings -->
    <DxForm :form-data="advControllerData"  label-location="left" :min-col-width="350">
      <DxGroupItem :col-count="2" :min-col-width="350" caption="Frequency">
        <DxSimpleItem data-field="repeat" editor-type="dxCheckBox" />
        <DxSimpleItem data-field="typeTask" 
          editor-type="dxSelectBox"
          :editor-options="{ disabled:(advControllerData.repeat==0), dataSource: typeTaskList, valueExpr:'id', displayExpr:'value', onValueChanged:changedTypeTask }" />
        <DxSimpleItem
         v-if="(advControllerData.repeat==1 && advControllerData.typeTask==0)"
          data-field="periodTask" 
          editor-type="dxNumberBox"
          :editor-options="{ maxLength: 300, showSpinButtons:true }"
          :label="{text:'Period [ms]'}"/>
          
        <DxSimpleItem 
         v-if="(advControllerData.repeat==1 && advControllerData.typeTask==1)"
          data-field="cronTask" 
          editor-type="dxTextBox"
          :editor-options="{maxLength: 300}"/>
      </DxGroupItem>

      <DxGroupItem :col-count="2" caption="Controlled Component">
        <DxSimpleItem
          data-field="connection_id" 
          editor-type="dxLookup"
          :value="assetDS.find(as=>as.id==advControllerData.connection_id)"
          :editor-options="{searchEnabled:true, showClearButton:true, dataSource: assetDS, valueExpr:'id', displayExpr:'name',onValueChanged: selectedAssetChanged}"
          :label="{text:'Component'}"/>

        <DxSimpleItem
          data-field="signal_id" 
          editor-type="dxLookup"
          :value="signalDS.find(s=> s.signalId==advControllerData.signal_id)"
          :editor-options="{searchEnabled:true, showClearButton:true, dataSource: signalDS, valueExpr:'signalId', displayExpr:'name'}"
          :label="{text:'Signal'}"/>
      </DxGroupItem>
    

      <!-- Signals  configuration-->
      <!--<div class="row mt-3">
        <h3 class="col-12 col-md-10">Signals for {{ controllerData.controllerId }}</h3>
        <div class="col-2">
          <DxButton
            text="+"
            type="normal"
            width="100%"
            @click="showAddSignalForm"
          />
        </div>
      </div>-->
      <!--<div class="row mt-1">
        <DxDataGrid
          ref="SignalsDG"
          :data-source="signalDS"
          :show-borders="true"
          :column-hiding-enabled="true"
          height="400px">
          <DxScrolling mode="virtual"/>
          <DxSelection mode="single" />
          <DxColumn data-field="name" :min-width="100" :allow-editing="false" />
          <DxColumn data-field="label" :hiding-priority="0" />
        </DxDataGrid>
      </div>-->

      <!--<h3 class="col-12 col-md-6 mt-4" v-if="(controllerData.compType!='MaxAutarchy')"> {{ controllerData.compType }} parameters </h3> -->

      <DxGroupItem :col-count="2" :min-col-width="350" caption="Advanced settings">      
        <DxSimpleItem 
          data-field="peakMaxPower"
          :label="{text:'Max Power [kW]'}" 
          editor-type="dxNumberBox" 
        />
        <DxSimpleItem 
          data-field="peakMinPower" 
          :label="{text:'Min Power [kW]'}" 
          editor-type="dxNumberBox" 
        />
        <DxSimpleItem 
          data-field="timeout"
          :label="{text:'Timeout [ms]'}" 
          editor-type="dxNumberBox" 
          :editor-options="{min:0,max:60000}"
        />
        <DxSimpleItem 
          data-field="max_OC_rec_time"
          :label="{text:'Reclosing Time [s]'}" 
          editor-type="dxNumberBox" 
          :editor-options="{min:0,max:60000}"
        />
        <DxSimpleItem 
          data-field="tolerance"
          :label="{text:'Tolerance'}" 
          editor-type="dxNumberBox" 
          :editor-options="{min:0,max:1}"
        />
        <DxEmptyItem/>
        <DxSimpleItem 
          data-field="socMin"
          :label="{text:'SoC Min [%]'}" 
          editor-type="dxNumberBox" 
          :editor-options="{min:0,max:100}"
        />
        <DxSimpleItem 
          data-field="socMax"
          :label="{text:'SoC Max [%]'}" 
          editor-type="dxNumberBox" 
          :editor-options="{min:0,max:100}"
        />
      </DxGroupItem>
    </DxForm>


    <!-- Choosing assets   --> 
    <div class="col mt-3">
      <h5>Enabled assets</h5>
      <div class="box">  
        <DxList
          :data-source="EnabledAssetsList"
          height="300"
          :show-selection-controls="true"
          selection-mode="multiple"
          v-model:selected-item-keys="SelectedItems"
        >
        </DxList>
      </div>
    </div>
    <div class="col-1 align-self-center " align="center">
      <div class="row-1  mb-4" >
        <DxButton
          id="back"
          icon="arrowright"
          @click="SelectAssetClick()"
        />
      </div>
    </div>
    <div class="col mt-3">
      <h5>Selected assets</h5>
      <div class="box">
        <DxList
          ref="selectedList"
          :data-source="SelectedAssetsList"
          :repaint-changes-only="true"
          key-expr="id"
          height="300"
          :allow-item-deleting="true"
          item-delete-mode="toggle"
        >
          <DxItemDragging
            data="doingTasks"
            :allow-reordering="true"
            :on-remove="onRemove"
            group="tasks"
          />
        </DxList>
      </div>
    </div>
  </div>
</template>

<script>

import {
  DxForm,
  DxSimpleItem,
  DxEmptyItem,
  DxGroupItem,
} from 'devextreme-vue/form';
import DxList, { DxItemDragging } from 'devextreme-vue/list';
import RawDataService from '../services/RawDataServiceTemplate';
import notify from 'devextreme/ui/notify';
import DxButton from 'devextreme-vue/button';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { ref,reactive } from '@vue/reactivity';

export default {
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxEmptyItem,
    DxList,
    DxItemDragging,
    DxButton,
  },
  data(){
    return{      
      typeTaskList :[
        {id:0, value: 'Periodic task'},
        {id:1, value: 'Cron task'},
      ]
    }
  },
  props:{
    controllerData:{
      id:null,
      name: null,
      uuid: null,
      description: null,
      isEnabled:null,
      compType:null
    },
    controllerList:{}
  },

  setup(props){

    const stErrorCb = err => { notify(err.message, "error", 3000); }

    const assetsDataService = new RawDataService('masters/assets');
    const signalDataService = new RawDataService('masters/signals');
    const controllerDataService = new RawDataService('controllers');
    
    const selectedList = ref(null)

    const advControllerData = reactive({
      repeat:0,
      typeTask:0,
      periodTask:1000,
      cronTask: '0 * * * *',
      connection_id: null,
      signal_id:null,

      peakMaxPower: null,
      peakMinPower: null,
      timeout: 1800,
      max_OC_rec_time: 0,
      tolerance: 0.004,
      socMin: 10,
      socMax: 100,

      selectedAssets:[]
  
    });

   
    // Enabled Assets
    const EnabledAssetsStore = new CustomStore({
      key: 'id',
    
      load: async() => {
        try{
          const newDs=[]
          const AllAssetsList = await assetsDataService.getAll();
          const assetList= AllAssetsList.filter(as=> as.isEnabled==1 ); // && as.assetType==1
          const includedAssets=[]
     
          for(const asset of advControllerData.selectedAssets){
             includedAssets.push(asset.text);
          }          
          for(const asset of assetList){
            if (!includedAssets.includes(asset.name)){
              newDs.push({
                id: asset.uuid,
                text: asset.name
              })
            }
          }
          return newDs;
        }catch(err) { notify('error loading enabled assets: '+err.message, 'error', 4000); }  
      },  
    });

    const EnabledAssetsList = new DataSource({
      store: EnabledAssetsStore,
      paginate: false
    }); 


    // Selected Assets
    const SelectedAssetsStore = new CustomStore({
      key: 'id',
    
      load: async() => {
        return advControllerData.selectedAssets;
      },  
      insert:() => {
    
      },
      remove: async(e) => {
        try{
          const value = advControllerData.selectedAssets.find(asset=>asset.id==e)
          const idx = advControllerData.selectedAssets.indexOf(value)
          advControllerData.selectedAssets.splice(idx,1)
          await EnabledAssetsList.reload();
        }catch(error){ stErrorCb(error); }
      }
    });

    const SelectedAssetsList = new DataSource({
      store: SelectedAssetsStore,
      paginate: false
    }); 

    
    /// Select an asset
    
    const SelectedItems=ref([]);
    const SelectAssetClick = async()=>{
      try{
        for (const asset of SelectedItems.value){
          let assetobj = EnabledAssetsList._items.find(p => p.id==asset);
          advControllerData.selectedAssets.push({
            id: assetobj.id,
            text: assetobj.text
          })
        }
        SelectedItems.value=[];
        await EnabledAssetsList.reload();
        await SelectedAssetsList.reload()
        selectedList.value.instance.repaint()
     
      }catch(error){ stErrorCb(error); }
    }
  

    /// SAVE 

    const saveControllerChanges = async () => {
      // Comun settings
      try{
        controllerDataService.update(props.controllerData.name, props.controllerData).then(res =>{        
          if(res.isOk){
            notify(res.message||"controller updated", "success", 3500)
          }else{
            notify(res.message||"unexpected response", "warn", 3500)
          }
        })
        
        // Advanced Settings
        const controllerParams = {
          controllerId: props.controllerId,
          paramName: 'static',
          paramSchema: JSON.stringify({type:'object', //TODO: save schemas in other file
                          properties:{
                          }}),
          value: JSON.stringify(advControllerData),
          description: null,
        }; 
        const paramsControllerService=  new RawDataService('controllers/'+ props.controllerData.id +'/params');
        const PowerParam  = await paramsControllerService.getAll();
        const Staticf=PowerParam.find?.(param=>{
          return param.paramName == 'static';
        });
          
        paramsControllerService.update(Staticf.param_id, controllerParams).then(res =>{        
          if(res.isOk){
            notify(res.message||"controller updated", "success", 3500)
          }else{
            notify(res.message||"unexpected response", "warn", 3500)
          }
        });
      }catch(error){
        stErrorCb(error);
      }
    }
    

    // signal list
   
    const signalDS=ref([])
    const selectedAssetChanged = async()=>{

      signalDS.value = []
       const component = assetDS.value.find(el => el.id == advControllerData.connection_id);
      if(component){
        signalDS.value = await signalDataService.getAll();
        signalDS.value=signalDS.value.filter(s=>s.assetName==component.name)

         if (!signalDS.value.find(s=>s.signalId == advControllerData.signal_id)){
          advControllerData.signal_id=null
        }
      }
    }

    /// LOAD ///////////////

    const assetDS = ref([])
    const loadById = async () => {
      // get advanced settings
      const paramsControllerService =  new RawDataService('controllers/'+ props.controllerData.id +'/params');
      const staticParam = await paramsControllerService.getAll().then(res => {
        const param = res.find(param => {
          return param.paramName == 'static';
        });
        return (param)
      }).catch(stErrorCb);

      Object.assign(advControllerData,JSON.parse(staticParam.value));  
      
      EnabledAssetsList.reload()
      SelectedAssetsList.reload();
     
      // Get asset list
      await assetsDataService.getAll().then(res =>{
        res.forEach((com)=>{
          assetDS.value.push({
            type:'asset',
            name: com.name,
            id:com.id
          })
        })
      });

      const component = assetDS.value.find(el => el.id == advControllerData.connection_id);
      if (component){
        signalDS.value = await signalDataService.getAll();
        signalDS.value=signalDS.value.filter(s=>s.assetName==component.name)
      }
    }

    loadById();


    return{
      advControllerData,
      saveControllerChanges,
      EnabledAssetsList,
      SelectedAssetsList,
      SelectAssetClick,
      SelectedItems,
      loadById,
      assetDS,
      signalDS,
      selectedAssetChanged,
      selectedList,
    }
  },
  methods:{
    
  }

}


</script>

<style>


#accordion h5 {
  font-size: 1rem;
}

#accordion h5,
#accordion p {
  margin: 0;
  padding: 0.2rem ;
}
#chart {
  height: 120px;
}
.box{
  border-color: gray;
  border-width: 1px;
  border-style: dotted;
}

</style>
